import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

export function getPersonType(id: number): JQueryPromise<modelsGet.IPersonType>
{
    var endpoint = new URI("api/person-types");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IPersonType>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Personenarten zurück.
 */
export function getPersonTypes(): JQueryPromise<modelsGet.IPersonType[]>
{
    var endpoint = new URI("api/person-types");

    return api.get<modelsGet.IPersonType[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(personType: modelsPost.IPersonType): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/person-types/create",
        data: JSON.stringify(personType)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, personType: modelsPost.IPersonType): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/person-types/edit/${id}`,
        data: JSON.stringify(personType)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/person-types/delete/${id}`
    });
}